module.exports = __webpack_public_path__ + "img/ic-ic-check-filled.d5ba2dc4.svg";